import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import DpaHiddenStringsPage from "@/pages/tools/DpaHiddenStrings";

export const Route = createFileRoute("/tools/dpa-hidden-strings")({
  head: () => seoHead("/tools/dpa-hidden-strings"),
  component: DpaHiddenStringsPage,
});
